export default __webpack_public_path__ + "afr_light.c5527368.svg";